export default function ({ store, route, redirect }) {
    //Redirect for old news article eg. http://localhost:3000/news/2015/12/29/jessica-alba-finally-speaks-about-the-alleged-sex-tape/
    const newsSlug = route.params.slug;
    redirect('/news/'+newsSlug);
    return
}